/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useSnackbar } from 'notistack';
import { useLocation } from 'react-router-dom';
// import { getAvailablePromotions } from './LoginService';
import { getErrorMessage } from 'src/utils/getAxiosErrorMessage';
import { getUserLoginData } from './LoginService';
import { useAppData, useLoading } from '../../providers';
import { clearThemeCache, getTranslations } from '../../layouts';
import { PATH_WELCOME, supportedLocales, languages, defaultLocale } from '../../utils';
import { setAmplitudeIdentity, trackAmplitudeData } from '../../services/amplitudeService';

export const LoginAsPartner: FC = () => {
  const { pagePath, saveUserData, translations, saveTranslations, saveToken, removeToken, saveLocale /* saveIsPromotionAvailable */ } = useAppData();
  const history = useHistory();
  const { setIsLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const { search } = useLocation();
  const Token = new URLSearchParams(search).get('Token')?.toString();
  const locale = new URLSearchParams(search).get('language')?.toString();

  const setPath = useCallback(
    (userLoginData: any) => {
      const routesArray: string[] = [];
      let defaultRoute = '';

      if (userLoginData.accounts != null && userLoginData.accounts.length > 0) {
        // All accounts
        const accountCollection = userLoginData.accounts;

        // Loop each account
        accountCollection.forEach((account: any) => {
          const { routeCollection } = account.role;
          defaultRoute = routeCollection.defaultRoute.route;
          const routeCollectionArray = routeCollection.routeCollectionHasRoute;

          routeCollectionArray.forEach((routeIndex: any) => {
            routesArray.push(routeIndex.route);
          });
        });
      }
      let path = defaultRoute;
      if (pagePath) {
        const exist = routesArray.filter((route) => route === pagePath || route.indexOf(pagePath) > -1).length > 0;
        path = exist ? pagePath : defaultRoute;
      }
      history.push(path);
    },
    [history, pagePath],
  );

  const getTranslationList = useCallback(
    async (newLocale: string) => {
      const translations = await getTranslations();
      saveTranslations(JSON.stringify(translations.data));
      saveLocale(newLocale);
    },
    [saveTranslations, saveLocale],
  );

  // PROMOTION IMPLEMENTATION PAUSED
  // const getPromotions = useCallback(async () => {
  //   const response = await getAvailablePromotions();
  //   if (response.data.length === 0) {
  //     saveIsPromotionAvailable(false);
  //   } else {
  //     saveIsPromotionAvailable(true);
  //   }
  // }, [saveIsPromotionAvailable]);

  const getLoginData = useCallback(async () => {
    const response = await getUserLoginData();
    const userData = response.data;
  
    const userId = userData?.userID ?? userData?.userId ?? userData?.id;
  
    if (userId) {
      sessionStorage.setItem('commissionDashboardUserId', String(userId));
    }
  
    if (userData.accounts[0].userRoleName !== 'Partner' && userData.accounts[0].role.id !== 7) {
      removeToken();
      history.push(PATH_WELCOME);
    } else {
      setAmplitudeIdentity(userData);
      saveUserData(JSON.stringify(userData));
      setPath(userData);
    }
  }, [saveUserData, setPath, removeToken]);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        saveToken(Token);

        const eventProperties = {
          accountType: 'Partner',
        };
        trackAmplitudeData('partnerPortal_login', eventProperties);

        if (locale && supportedLocales.includes(locale)) {
          const selectedLanguage = languages.find((item) => item.value === locale) || languages[0];
          if (selectedLanguage.value !== languages[0].value) {
            trackAmplitudeData('partnerPortal_action_languageChanged', {
              page_language: selectedLanguage.value,
            });
          }
          saveLocale(selectedLanguage.value);
          await getTranslationList(locale);
        } else {
          await getTranslationList(defaultLocale);
        }

        await clearThemeCache();
        await getLoginData();
        setIsLoading(false);
        // await getPromotions();
      } catch (error: unknown) {
        const errorMessage = getErrorMessage(error);
        removeToken();
        enqueueSnackbar(errorMessage, { variant: 'error' });
        history.push(PATH_WELCOME);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [getLoginData, Token, locale]);
  return <div />;
};
